export { default as translations } from './translations.json';

/**
 * Get auction config from listing.
 * @param {Object|null} listing
 * @returns {Object|null}
 */
export const getAuctionConfig = (listing) => {
  const auction = listing?.attributes?.publicData?.auction;
  return auction?.enabled ? auction : null;
};

/**
 * Check if auction is still active.
 * @param {Object|null} auction
 * @param {Date} [now]
 * @returns {boolean}
 */
export const isAuctionActive = (auction, now = new Date()) =>
  !!auction && new Date(auction.endAt) > now;

/**
 * Get current top bid from bids array.
 * @param {Object[]} bids
 * @returns {number|null}
 */
export const getTopBid = (bids) => {
  if (!Array.isArray(bids) || bids.length === 0) return null;
  return Math.max(...bids.map(b => b.amount));
};

/**
 * Calculate minimum next bid.
 * @param {number|null} topBid
 * @param {Object} auction
 * @returns {number}
 */
export const getMinimumBid = (topBid, auction) => {
  const increment = auction?.minBidIncrementCents || 100;
  return (topBid ?? (auction?.startPriceCents ?? 0) - increment) + increment;
};
